import { render } from "./TilesPage.vue?vue&type=template&id=f1227dac"
import script from "./TilesPage.vue?vue&type=script&lang=js"
export * from "./TilesPage.vue?vue&type=script&lang=js"

import "@/css/StockPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__